import ApplicationController from "../../../../../application_controller"

export default class extends ApplicationController {
  static targets = ["reason", "other", "otherInput"]

  connect() {
    if (this.hasReasonTarget) this.updateReason()
  }

  updateReason() {
    const show = this.reasonTarget.value === "other"
    this.otherTarget.hidden = !show
    this.otherInputTarget.disabled = !show
    this.otherInputTarget.required = show
  }
}
